// ===================================================
// Утилита: активные модули для левого Sidebar и HelperSidebar
// Список ключей в DEFAULT должен покрывать `isHrefVisibleWithActiveModules` в
// `activeModulesHrefFilter.js` (и sidebar.config, который вызывает его).
// ===================================================
//
// Проблемы, которые решает:
// 1) Пустой массив `company.settings.modules: []` — раньше трактовался как truthy
//    и скрывал ВСЕ пункты с проверкой модуля.
// 2) Неполный дефолт — не хватало ключей orders, hrm, files, sklad, power →
//    пункты «Заказы поставщикам», HRM, «Файлы», WMS, POWER исчезали из меню.
// 3) Супер- / платформенный админ — полный обход allowlist: ['all'].

/**
 * Все `modName`, участвующие в фильтрации `buildNavigationHubs` (block + finance URLs).
 * Используется как «включено по умолчанию», пока сервер не прислал явный allowlist.
 */
export const DEFAULT_ACTIVE_MODULES_FOR_NAV = [
  // Каталог и операции (ProtectedRoute moduleKey в App.js)
  'products',
  'warehouses',
  'suppliers',
  'marketplaces',
  'sync',
  'dictionaries',
  'automations',
  'widgets',
  // Блоки sidebar + activeModulesHrefFilter
  'shop',
  'feed',
  'crm',
  'docs',
  'kassa',
  'logistics',
  'delivery',
  'finance',
  'integrations',
  'analytics',
  'torg',
  'notifications',
  'services',
  'legal',
  'support',
  'waygen',
  'orders',
  'hrm',
  'files',
  'search',
  'bonus',
  'sklad',
  'power',
];

/**
 * @param {object|null|undefined} company — текущая компания из auth (server-derived)
 * @param {{ isSuperAdmin?: boolean }} [options]
 * @returns {string[]}
 */
export function resolveActiveModulesNav(company, options = {}) {
  const { isSuperAdmin = false } = options;

  if (isSuperAdmin) {
    return ['all'];
  }

  const fromCompany = company?.settings?.modules;
  const raw = fromCompany !== undefined && fromCompany !== null ? fromCompany : null;

  if (raw === undefined || raw === null) {
    return DEFAULT_ACTIVE_MODULES_FOR_NAV;
  }

  if (Array.isArray(raw)) {
    if (raw.length === 0) {
      return DEFAULT_ACTIVE_MODULES_FOR_NAV;
    }
    if (raw.includes('all')) {
      return ['all'];
    }
    return raw;
  }

  if (raw && typeof raw === 'object') {
    const keys = Object.entries(raw)
      .filter(([, v]) => v === true || v === 'true' || v === 1)
      .map(([k]) => k);
    if (keys.length === 0) {
      return DEFAULT_ACTIVE_MODULES_FOR_NAV;
    }
    return keys;
  }

  return DEFAULT_ACTIVE_MODULES_FOR_NAV;
}
